import type { SVGProps } from 'react';
const SvgPersonRemoveAlt1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#person_remove_alt_1_svg__a)">
      <path
        fill="currentColor"
        d="M14 8c0-2.21-1.79-4-4-4S6 5.79 6 8s1.79 4 4 4 4-1.79 4-4Zm3 2v2h6v-2h-6ZM2 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4Z"
      />
    </g>
    <defs>
      <clipPath id="person_remove_alt_1_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPersonRemoveAlt1;
